

export const AuthEndpoints = {
  Login: 'Authenticate/Login',
  LoginStart: 'Authenticate/login/start',
  LoginPassword: 'Authenticate/login/password',
  Refresh: 'Authenticate/Refresh',
  SendAccountVerifyOTP: 'Authenticate/SendAccountVerifyOTP',
  // Terms sign-off: the last gate of a sign-in. Anonymous — the caller holds a terms token, not a JWT.
  TermsPending: 'TermsAcceptance/Pending',
  TermsAccept: 'TermsAcceptance/Accept',
  TermsPolicy: 'TermsAcceptance/Policy',
  MfaSend: 'Mfa/Send',
  MfaVerify: 'Mfa/Verify',
  MfaPhoneSend: 'Mfa/phone/send',
  MfaPhoneVerify: 'Mfa/phone/verify',
  PasskeyRegisterOptions: 'Passkey/register/options',
  PasskeyRegisterComplete: 'Passkey/register/complete',
  PasskeyLoginOptions: 'Passkey/login/options',
  PasskeyLoginComplete: 'Passkey/login/complete',
  PasskeyList: 'Passkey/list',
  PasskeyRevoke: 'Passkey',
  PasskeySnooze: 'Passkey/prompt/snooze',
  DeviceList: 'Device/list',
  DeviceRevoke: 'Device',
  ActivationStatus: 'Activation/status',
  ActivationVerifyIdentity: 'Activation/verify-identity',
  ActivationVerifyPhone: 'Activation/verify-phone',
  ActivationVerifyEmail: 'Activation/verify-email',
  ActivationResend: 'Activation/resend',
  ActivationSetPassword: 'Activation/set-password',
  ActivationPasskeyOptions: 'Activation/passkey/options',
  ActivationPasskeyComplete: 'Activation/passkey/complete',
  PayBevAutoLogin: 'Authenticate/SsoLogin',
  LogOut: 'Authenticate/LogOut',
  GetSiteAndAgencyDetails: 'Authenticate/SiteLogin',
  ForgotPassword: 'Authenticate/ForgotPassword',
  ResetPassword: 'Authenticate/ResetPassword',
  // Security > Password: emails the signed-in caller their own reset link. Takes no body — the
  // account and the portal both come from the JWT.
  SendPasswordResetLink: 'Authenticate/password/reset-link',
  VerifyTokenToResetPassword: 'Account/verifytoken',
  ChnagePassword: 'User/changepassword',
  ChangePassword: 'Authenticate/ChangePassword',
  GetMaintainanceStatus: '/Authenticate/GetMaintainanceStatus',
  SsoHandoff: 'Authenticate/sso/handoff',
} as const;
